/**
 * Read-only client for the shared Fannie DU credit-reissue vendor catalog (`dbo.CreditCompanies`).
 * Rides the SkynetAPI gateway (httpSkynetApi), not the Accounts subCompanies host — mirrors the
 * sibling `/api/admin-panel/sub-companies/...` BFF endpoints (DEV-5596).
 */
export class CreditCompaniesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCreditCompanies({ config = {} } = {}) {
    return this.#http.get('/api/admin-panel/credit-companies', config);
  }
}
